<p-dialog [header]="header | translate" [(visible)]="visible" [modal]="true"
  styleClass="edit-profile-popup" position="center center"
  [contentStyle]="{'overflow-y':'scroll', 'border-radius': 0}" class="cancel-popup-footer" contentStyleClass="py-0 pr-3"
  (onHide)="onHide()">
  @if (showWarning) {
    <div>
      <span id="label_warning_with_colon" class="warning" translate>label_warning_with_colon</span>
      <span id="label_cancel_multi_vehicle_booking_note" class="warning-text"
      translate>label_cancel_multi_vehicle_booking_note</span>
    </div>
  }

  @if (showAssociateBookings) {
    <div class="col-12 cancel-booking px-0 common-border-radius">
      <p-table class="table-cancel-booking" [value]="bookingToCancel" [(selection)]="selectedBookingToCancel"
        dataKey="tripId">
        <ng-template pTemplate="header">
          <tr>
            <th>
              <p-tableHeaderCheckbox [disabled]="showHideSelectAll"></p-tableHeaderCheckbox>
            </th>
            <th translate>label_BookingId</th>
            <th translate>label_booking_status</th>
            <th translate>label_driver_info</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-associateBooking>
          <tr>
            <td>
              <p-tableCheckbox [value]="associateBooking"
                [disabled]="isBookingDisabled(associateBooking.tourStatus)"></p-tableCheckbox>
            </td>
            <td>{{ associateBooking.tripId }}</td>
            <td>{{ associateBooking.tourStatusStr }}</td>
            <td>
              <ng-container
                *ngIf="associateBooking.driverName || associateBooking.vehicleCode || associateBooking.vehicleRegistration || associateBooking.vehicleMakeModel || associateBooking.vehicleModelName; else noData">
                <div class="driver-name" *ngIf="associateBooking.driverName">
                  {{ associateBooking.driverName }}
                </div>
                <div class="vehicle-code" *ngIf="associateBooking.vehicleCode">
                  {{ associateBooking.vehicleCode }} - {{ associateBooking.vehicleRegistration }}
                </div>
                <div class="vehicle-make" *ngIf="associateBooking.vehicleMakeModel">
                  {{ associateBooking.vehicleMakeModel }} | {{ associateBooking.vehicleModelName }}
                </div>
              </ng-container>
              <ng-template #noData> NA </ng-template>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="col-12 grid align-items-center">
      <div class="col-1 pl-3">
        <img src="/assets/images/temp/canel-booking-warning-icon.svg" alt="img">
      </div>
      <div class="col-11 cancel-info">
        You cannot cancel the booking whose status is <span style=" font-weight: 900;">On Trip / Completed.</span>
        Do you wish to proceed?
      </div>
    </div>
  }

  @if (showPassengerNotification) {
    <div class="mt-3">
      <label id="label_passenger_notification" class="secondHeading my-3" translate>label_passenger_notification</label>
      <textarea id="label_passenger_notification_value" rows="5" cols="30" class="cancellationReason mt-3 p-2"
      maxlength="150" [(ngModel)]="passengerNote" pInputTextarea
      #passengerNoteRef="ngModel"
      [pattern]="restrictSpecialSymbol"></textarea>
      <small id="max_length_booking_note_150_char" translate>max_length_booking_note_150_char</small>
      @if(passengerNoteRef?.errors){
        <div translate class="form-errors">restrict_only_special_symbol</div>
      }
    </div>
  }
  <div class="mt-3">
    <label id="label_booking_note" class="secondHeading my-3" translate>label_booking_note</label>
    <textarea id="label_booking_note_value" rows="5" cols="30" class="cancellationReason p-2 mt-3" maxlength="150"
    [(ngModel)]="bookingNote" pInputTextarea
    #bookingNoteRef="ngModel"
    [pattern]="restrictSpecialSymbol"></textarea>
    <small id="max_length_booking_note" translate>max_length_booking_note_150_char</small>
    @if(bookingNoteRef?.errors){
      <div translate class="form-errors">restrict_only_special_symbol</div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="pr-3 flex align-items-center justify-content-end gap-2">
      @if(isSmsEnabled) {
        <p-checkbox [(ngModel)]="sendSms" binary="true" [inputId]="'sendSms'"></p-checkbox>
        <label for="sendSms" translate>label_sms</label>
      }
      @if(isEmailEnabled) {
        <p-checkbox [(ngModel)]="sendEmail" binary="true" [inputId]="'sendEmail'"></p-checkbox>
        <label for="sendEmail" translate>label_email</label>
      }
      <button id="label_cancel_button" class="negative-button" pButton appRipple type="button"
      [label]="'label_cancel' | translate" (click)="cancel()"></button>
      <button id="label_confirm_button" pButton appRipple type="button" [label]="'label_confirm' | translate"
      [disabled]="bookingNoteRef?.errors || passengerNoteRef?.errors || (showAssociateBookings && selectedBookingToCancel.length === 0)"
      (click)="confirm()"></button>
    </div>
  </ng-template>
</p-dialog>
